import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import IconButton from '@material-ui/core/IconButton';
import { FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';

import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from '@material-ui/core';


/**
 * Material UI button with a confirm dialog.
 * When the button is clicked a confirm dialog pops up.
 * 
 * The dialog contains 2 buttons: "yes" and "no".
 * Clicking on "no" close the popup.
 * Clicking on "yes" trigger the onClick action given in props.
 * If a "working" prop is given, the dialog is closed once the "yes"
 * button has been clicked and the "working" prop is false. 
 * 
 * A circular progress is displayed on the "yes" button 
 * of the dialog when "working" prop is true
 * 
 * The button has a Default style corresponding to 
 * the theme (small, primary color)
 */

const styles = theme => ({
  progress: {
    marginRight: theme.spacing.unit
  }
})

class ConfirmButton extends Component {

  state = {
    open: false
  };

  handleOpenDialog = () => {
    this.setState({ open: true });
  }

  handleCloseDialog = () => {
    this.setState({ open: false });
  }

  handleConfirm = () => {
    this.props.onClick();
    this.setState({ 
      choosenAction: 'confirm',
      open: typeof this.props.working !== 'undefined'
    });
  }

  handleProceed = () => {
    this.props.proceed();
    this.setState({ 
      choosenAction: 'proceed',
      open: typeof this.props.working !== 'undefined'
    });
  }

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if(prevProps.working && !this.props.working && this.state.open) {
      this.setState({
        open: false
      });
    }
  }

  render() {
    const { 
      message, 
      working, 
      onClick, 
      proceed,
      children, 
      title,
      yes,
      no,
      cancel,
      iconButton,
      classes,
      color,
      size="medium",
      ...props 
    } = this.props;

    const ButtonComponent = iconButton ? IconButton : Button;

    const buttonColor = color || (cancel ? "secondary" : "primary");

    return [
      <ButtonComponent
        key="confirmButton"
        color={buttonColor}
        size={size}
        {...props}
        onClick={this.handleOpenDialog} 
      >
        {children}
      </ButtonComponent>
      ,
      <Dialog
        key="confirmDialog"
        fullScreen={false}
        open={this.state.open}
        aria-labelledby="responsive-dialog-title">

        <DialogTitle id="responsive-dialog-title">
          {title || <FormattedMessage id='confirm.dialogTitle' />}
        </DialogTitle>
        <DialogContent>
          {message || <FormattedMessage id='confirm.dialog.default.message' />}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" working={working && this.state.choosenAction === 'confirm'} disabled={working} onClick={this.handleConfirm} color="primary">
            {yes || <FormattedMessage id='confirm.dialog.yes.button' />}
          </Button>
          <Button working={working && this.state.choosenAction === 'proceed'} disabled={working} onClick={proceed? this.handleProceed : this.handleCloseDialog} color="primary">
            {no || <FormattedMessage id='confirm.dialog.no.button' />}
          </Button>
        </DialogActions>
      </Dialog>
    ]
  }
}


ConfirmButton.propTypes = {
  message: PropTypes.object,
  onClick: PropTypes.func.isRequired,
  working: PropTypes.bool.isRequired,
}

export default withStyles(styles)(ConfirmButton);


// WEBPACK FOOTER //
// ./src/components/ConfirmButton.js